export const variantStyles = {
    primary: {
        bgColor: 'neutral.10',
        borderColor: 'neutral.40',
        textColor: 'text.100',
        fontToken: 'bodyBaseDefault',
    },
    success: {
        bgColor: 'alert.success.10.active.default',
        borderColor: 'alert.success.50.active.default',
        textColor: 'alert.success.10.active.onColor',
        fontToken: 'bodyBaseDefault',
    },
};
